import { render, staticRenderFns } from "./UserPaymentFailModal.vue?vue&type=template&id=afcbdf48&scoped=true"
import script from "./UserPaymentFailModal.vue?vue&type=script&lang=js"
export * from "./UserPaymentFailModal.vue?vue&type=script&lang=js"
import style0 from "./UserPaymentFailModal.vue?vue&type=style&index=0&id=afcbdf48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afcbdf48",
  null
  
)

export default component.exports